import Tags from "./Tags";
import { Flex } from "@chakra-ui/react";
import { PrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import { TipoArrecadacaoEnum } from "features/arrecadacoes/enums";
import { formatMoney } from "infra/helpers/number";

interface ContentTagPorps {
  item: PrevisaoOrcamentaria;
}

export default function ContentTags({ item }: ContentTagPorps) {
  function getTipoArrecardacao(event: TipoArrecadacaoEnum) {
    switch (event) {
      case TipoArrecadacaoEnum.ValorIgualTodasUnidades:
        return "Igual para todas as unidades do condomínio";
      case TipoArrecadacaoEnum.ValorMetrosUnidade:
        return "Para cada M² da unidade";
      default:
        return "";
    }
  }

  return (
    <Flex>
      <Tags
        title={`${getTipoArrecardacao(
          item.tipoArrecadacaoId as TipoArrecadacaoEnum
        )}  de ${
          item.valorArrecadacao ? formatMoney(item.valorArrecadacao) : 0
        }`}
        colorScheme="cyan"
      />
    </Flex>
  );
}
